import { Plate } from '@/commonTypes';

/** Convert Western digits in a string to Persian digits. */
export function faNum(n: string | number): string {
  return String(n).replace(/\d/g, (x) => '۰۱۲۳۴۵۶۷۸۹'[Number(x)]);
}

/** Format a plate as "a b c | r". */
export function faPlate(p: Plate | null | undefined): string {
  return p ? `${p.a} \u200E  ${p.b} \u200E  ${p.c} | ${p.r}` : '';
}
/** Avatar gradient palette, indexed round-robin. */
export function avatarBg(i: number): string {
  const g = [
    'linear-gradient(135deg,var(--accent),var(--pink))',
    'linear-gradient(135deg,var(--brand),var(--brand-light))',
    'linear-gradient(135deg,var(--purple),var(--pink))',
    'linear-gradient(135deg,var(--green-bright),var(--brand))',
    'linear-gradient(135deg,#FF9A52,var(--accent-red))',
    'rgba(255, 255, 255, 0.12)',
    'linear-gradient(135deg, rgb(232, 238, 251), rgb(244, 247, 255))',
    'rgb(253, 236, 231)',
    'rgb(254, 243, 226)',
    '#E6F7EE',
  ];
  return g[i % g.length];
}
export function blogBg(i: number): string {
  const g = [
    'linear-gradient(135deg,var(--accent),var(--pink))',
    'linear-gradient(135deg,var(--brand),var(--brand-light))',
    'linear-gradient(135deg,var(--purple),var(--pink))',
    'linear-gradient(135deg,var(--green-bright),var(--brand))',
    'linear-gradient(135deg,#FF9A52,var(--accent-red))',
  ];
  return g[i % g.length];
}
export function lightBg(i: number): string {
  const g = ['var(--danger-bg)', 'var(--tag-bg)', 'var(--purple-bg)', 'var(--green-bg)'];
  return g[i % g.length];
}
export function lightBgIcon(i: number): string {
  const g = ['var(--danger)', 'var(--brand-deep)', 'var(--purple)', 'var(--green)'];
  return g[i % g.length];
}
export const brandColors = [
  'linear-gradient(135deg,var(--accent),var(--pink))',
  'linear-gradient(135deg,var(--brand),var(--brand-light))',
  'linear-gradient(135deg,var(--purple),var(--pink))',
  'linear-gradient(135deg,var(--green-bright),var(--brand))',
  'linear-gradient(135deg,#FF9A52,var(--accent-red))',
  'linear-gradient(135deg, rgb(22, 48, 122), rgb(36, 75, 196))',
  'linear-gradient(135deg, rgb(255, 138, 54), rgb(255, 176, 90))',
  'linear-gradient(135deg, rgb(14, 21, 37), rgb(58, 66, 86))',
];
export function brandBg(i: number): string {
  const g = brandColors;
  return g[i % g.length];
}

export function avatarBgGlow(i: number): string {
  const g = [
    'rgba(255,110,40,.32)',
    'rgba(45,107,255,.3)',
    'rgba(122,91,255,.3)',
    'rgba(60,230,160,.28)',
    'transparent',
    'transparent',
  ];
  return g[i % g.length];
}

export function BankCardBg(i: number): string {
  const g = [
    'linear-gradient(120deg, #1A2A5C, #3A2C7A)', // Navy → Purple
    'linear-gradient(120deg, #16307A, #244BC4)', // Royal Blue
    'linear-gradient(120deg, #0F4C5C, #1D7874)', // Teal
    'linear-gradient(120deg, #283E51, #4B79A1)', // Slate Blue
    'linear-gradient(120deg, #1F3B73, #4062BB)', // Indigo
    'linear-gradient(120deg, #234E70, #3B82C4)', // Steel Blue
    'linear-gradient(120deg, #2B5876, #4E4376)', // Blue Violet
    'linear-gradient(120deg, #304352, #4B6CB7)', // Gray Blue
    'linear-gradient(120deg, #0B486B, #3B82F6)', // Ocean
    'linear-gradient(120deg, #2C3E50, #3498DB)', // Midnight → Sky
  ];
  return g[i % g.length];
}
